/** Terms & Privacy — Deutsch. Aktuell vor allem 1:1; Gruppen, Kanäle und Moderation können später folgen. */
export const legalDocumentsDe = {
  termsFull: `1. Zustimmung zu diesen Bedingungen

Mit Erstellung eines Kontos, Anmeldung oder anderer Nutzung von Duvpost („Dienst“, „wir“) erklären Sie sich mit diesen Nutzungsbedingungen einverstanden. Wenn Sie nicht einverstanden sind, nutzen Sie den Dienst nicht.

2. Was Duvpost ist

Duvpost ist eine Webanwendung für Nachrichten und Echtzeitkommunikation, betrieben in kleinem Rahmen.

Derzeit liegt der Schwerpunkt auf Echtzeit-Einzelchats, Dateianhängen, Sprach- und Videoanrufen zwischen einzelnen Nutzern, Meet-ähnlichen Räumen per Link sowie Entdeckung und Profil (z. B. People) mit E-Mail/Passwort oder Google-Anmeldung. Gruppenunterhaltungen, Kanäle und eigene Moderationsabläufe sind in der aktuellen Version keine Pflichtfunktionen, können aber später ohne separate Vereinbarung eingeführt werden; gelten dann ebenfalls diese Bedingungen.

Wir können Funktionen im Zeitverlauf hinzufügen, ändern oder entfernen. Nicht jede hier beschriebene Funktion ist in Ihrer Region, auf Ihrem Tarif oder in Ihrer App-Version jederzeit verfügbar.

Der Dienst nutzt Google Firebase (Authentication, Firestore, Storage, Cloud Functions und zugehörige Infrastruktur) und weitere in der Datenschutzerklärung genannte Komponenten.

3. Voraussetzungen

Mindestens 16 Jahre oder höheres Mindestalter in Ihrem Land. Minderjährige nur mit Zustimmung eines Erziehungsberechtigten. Keine wissentliche Erhebung von Daten Kindern unter dem geltenden Alter.

4. Ihr Konto

Wahrheitsgemäße Angaben, sichere Zugangsdaten, Verantwortung für Aktivitäten unter Ihrem Konto. Bei Kompromittierungsverdacht uns über die veröffentlichten Kontaktwege informieren.

Bei kostenpflichtigen Plänen (z. B. „Premium“) werden Gebühren, Abrechnungszyklen und Steuern beim Kauf angezeigt. Nichtzahlung kann Herabstufung oder Verlust bezahlter Funktionen zur Folge haben.

5. Pläne, Speicherlimits und Aufbewahrung

Wir können verschiedene Kontostufen anbieten (z. B. Standard/kostenlos und kostenpflichtig). Grenzen — z. B. maximale Dateigröße, Gesamtspeicher, gleichzeitige Uploads oder automatische Löschung von Anhängen nach einer Frist — können je Tarif variieren und sich ändern. Wir bemühen uns, wesentliche Änderungen nach Möglichkeit vorher mitzuteilen (z. B. in der App, per E-Mail oder aktualisierten Bedingungen), vorbehaltlich gesetzlicher Pflichten.

Bei eingeschränkten Tarifen können hochgeladene Dateien nach einer von uns angegebenen Frist oder bei Überschreitung von Kontingenten automatisch gelöscht werden. Höhere Tarife können größere Limits, längere Aufbewahrung oder weniger Einschränkungen bieten; „unbegrenzt“ bleibt fair-use- und missbrauchsbegrenzt.

Sie sind für eigene Backups wichtiger Daten verantwortlich. Der aktuelle Dienst speichert Chatnachrichten und hochgeladene Chatdateien 14 Tage ab Erstellung und löscht sie danach automatisch. Unbegrenzte dauerhafte Speicherung von Nutzerinhalten garantieren wir nicht.

6. Nutzerinhalte

Sie behalten Rechte an Ihren Inhalten. Sie gewähren uns eine beschränkte, weltweite, nicht ausschließliche Lizenz zur Speicherung, Vervielfältigung, Übertragung und Anzeige, soweit nötig um den Dienst zu betreiben und zu sichern, diese Bedingungen durchzusetzen und dem Recht zu genügen — Einzelchats, Anrufe, Meet sowie bei Einführung Gruppen, Kanäle und zugehörige Funktionen.

Wir beanspruchen kein Eigentum an Ihren Inhalten. Nachrichteninhalte können verschlüsselt gespeichert werden; Details in der Datenschutzerklärung. Sie sind für Rechtmäßigkeit und Rechte Dritter verantwortlich. Sobald Gruppen oder Kanäle existieren, gelten dort ebenfalls geltendes Recht und diese Bedingungen; wir können zusätzliche Regeln veröffentlichen.

7. Zulässige Nutzung

Untersagt u. a.: rechtswidrige, schädliche, belästigende oder diskriminierende Nutzung; Malware/Phishing; unbefugter Zugriff; Missbrauch von APIs; Identitätsmissbrauch; Verletzung von IP- oder Datenschutzrechten; Spam; Nutzung offener oder auffindbarer Kanäle und ähnlicher Funktionen, falls und sobald angeboten, für rechtswidrige Inhalte.

Wir können den Zugang sperren oder Inhalte entfernen oder einschränken, wenn dies gesetzlich oder nach diesen Bedingungen geboten ist. Wir haben keine allgemeine Pflicht, sämtliche Nutzerkommunikation zu überwachen; führen wir Melde- oder Moderationswerkzeuge ein, garantiert deren Nutzung keine bestimmte Reaktionszeit oder ein bestimmtes Ergebnis.

8. Anrufe und Drittinfrastruktur

Sprach/Video (einschließlich Gruppenanrufen, falls hinzugefügt): Medien P2P oder über Relay (TURN). Netz- und Relaybetreiber verarbeiten nach eigenen Regeln. Browser-/OS-Berechtigungen steuern Sie selbst.

9. Drittanbieter

Google/Firebase; bei Zahlungen Zahlungsdienstleister mit eigenen Bedingungen. Linkvorschauen können Drittsites anfragen.

10. Geistiges Eigentum

Marke und Software von Duvpost (außer Ihren Inhalten) sind geschützt.

11. Gewährleistungsausschluss

Der Dienst wird „wie besehen“ und „nach Verfügbarkeit“ bereitgestellt. Im gesetzlich zulässigen Umfang schließen wir alle ausdrücklichen, stillschweigenden und gesetzlichen Gewährleistungen aus, einschließlich Handelsüblichkeit, Eignung für einen bestimmten Zweck, ungestörter Nutzung und Nichtverletzung.

Wir garantieren keinen unterbrechungs- oder fehlerfreien Betrieb, keine Beseitigung von Mängeln, keine freien Server von Schadsoftware sowie nicht, dass Daten niemals verloren gehen, beschädigt werden oder offengelegt werden. Der Dienst ist kein Backup-Archiv, kein Ersatz für medizinische, rechtliche oder finanzielle Beratung, kein Notdienst und kein Aufzeichnungssystem für gesetzliche Pflichten, sofern nicht ausdrücklich schriftlich anders vereinbart.

Wir sind nicht verantwortlich für Richtigkeit, Rechtmäßigkeit oder Qualität von Inhalten anderer Nutzer. Nutzung des Dienstes und Verlassen auf Inhalte erfolgen auf Ihr eigenes Risiko.

12. Haftungsbeschränkung

Im gesetzlich zulässigen Umfang haften wir, unsere Lieferanten, Geschäftsführer und Mitarbeiter nicht für indirekte, zufällige, besondere, Folge- oder Strafschäden, entgangenen Gewinn, Umsatz, Daten, Goodwill oder Chancen, auch wenn die Möglichkeit solcher Schäden bekannt war.

Unsere Gesamthaftung aus allen Ansprüchen im Zusammenhang mit dem Dienst oder diesen Bedingungen ist begrenzt auf den höheren Betrag aus (a) Ihren Zahlungen für den Dienst in den zwölf (12) Monaten vor dem Anspruch oder (b) 50 EUR ohne Zahlungen. Dies gilt unabhängig von der Rechtsgrundlage (Vertrag, Delikt einschließlich Fahrlässigkeit, verschärfte Haftung), außer wo das Gesetz solche Beschränkungen verbietet (z. B. Tod oder Körperverletzung durch unsere Fahrlässigkeit, Betrug).

Soweit in Ihrer Rechtsordnung bestimmte Beschränkungen unzulässig sind, ist unsere Haftung auf das gesetzlich Höchstmaß beschränkt.

13. Freistellung

Sie stellen uns von Ansprüchen, Schäden, Verlusten und angemessenen Rechtskosten frei, die aus Ihrer Nutzung, Ihren Inhalten oder Ihrem Verstoß entstehen, außer bei vorsätzlichem Fehlverhalten unsererseits.

14. Beendigung

Jederzeit nutzungsbeendbar; wir können sperren bei Verstoß, Sicherheitsrisiko, Nichtzahlung oder gesetzlichen Gründen. Bestimmungen, die ihrer Natur nach fortgelten (Haftungsgrenzen, Freistellung, anwendbares Recht), bleiben bestehen.

15. Änderungen

Wir können die Bedingungen aktualisieren und das Datum „Zuletzt aktualisiert“ anpassen. Wesentliche Änderungen können nach gesetzlichen Vorgaben zusätzliche Mitteilung oder Zustimmung erfordern. Fortgesetzte Nutzung nach Inkrafttreten gilt als Annahme, sofern das Gesetz nichts anderes vorschreibt.

16. Anwendbares Recht und Streitigkeiten

Es gilt das Recht des Landes, in dem der Betreiber des Dienstes seinen eingetragenen Sitz oder Hauptniederlassung hat, ohne die zwingenden Verbraucherschutzvorschriften zu beeinträchtigen, die für Sie in Ihrem gewöhnlichen Aufenthaltsstaat gelten.

Sind Sie Verbraucher mit gewöhnlichem Aufenthalt im Europäischen Wirtschaftsraum, können Sie sich auf zwingende Vorschriften des Rechts Ihres Aufenthaltsstaates stützen, soweit vorgesehen, und uns vor den Gerichten Ihres Wohnsitzes verklagen, soweit das Gesetz dies verlangt. Wir können Klagen gegen Sie vor den Gerichten unseres Sitzes oder, soweit zulässig, in Ihrem Wohnsitzstaat erheben.

17. Sonstiges

Sollte eine Bestimmung unwirksam sein, bleiben die übrigen wirksam. Diese Bedingungen zusammen mit der Datenschutzerklärung und tarifspezifischen Bedingungen beim Kauf bilden die gesamte Vereinbarung. Sie dürfen Rechte ohne unsere Zustimmung nicht abtreten; wir dürfen im Zusammenhang mit Fusion, Erwerb oder Vermögensveräußerung abtreten. Unterlassung der Durchsetzung ist kein Verzicht. Für Verzögerungen oder Ausfälle durch höhere Gewalt haften wir nicht.

18. Kontakt

Fragen zu diesen Bedingungen: Betreiber über die in der App (z. B. About) oder auf der Website veröffentlichten Kontaktdaten.

Zuletzt aktualisiert: März 2026`,

  privacyFull: `1. Einleitung

Diese Datenschutzerklärung beschreibt die Verarbeitung personenbezogener Daten bei Nutzung von Duvpost. Ergänzend zu den Nutzungsbedingungen.

Der Dienst wird in kleinem Rahmen betrieben; Funktionen können wachsen (Gruppen, Kanäle, Gruppenanrufe, kostenpflichtige Tarife, Moderation). Die Erklärung beschreibt die Verarbeitung entsprechend dem bereitgestellten Produkt und einer vernünftig erwartbaren Weiterentwicklung.

2. Verantwortlicher

Der Betreiber Ihrer Duvpost-Bereitstellung, angegeben in der App (z. B. About) oder auf der Domain. Für Anfragen die veröffentlichten Kontaktdaten.

3. Verarbeitete Daten

Je nach Nutzung: Konto/Auth; Profil/Entdeckung (People); Nachrichten (derzeit vor allem 1:1; Gruppenthreads bei Einführung); Kanäle falls angeboten; Anhänge mit Limits und Aufbewahrung je Tarif; Anrufe/Meet inkl. Gruppen falls vorhanden; Zahlungen/Abonnements; technische Daten; App Check/reCAPTCHA; lokale Speicherung; Linkvorschauen. Chat-Inhalte nicht zum Training öffentlicher KI-Modelle.

4. Zwecke und Rechtsgrundlagen

Vertragserfüllung; Sicherheit, Kontingente, Aufbewahrung; Rechtspflichten; transaktionale E-Mails; Zahlungen. Einwilligung separat für Marketing/nicht notwendige Cookies falls eingeführt.

5. Auftragsverarbeiter

Google Firebase und verwandte Google-Dienste; aktuelle Liste und Dokumentation: https://firebase.google.com/support/privacy sowie Google-Cloud-/Firebase-Datenverarbeitungsbedingungen. Ggf. Zahlungsdienstleister, Hosting, E-Mail.

6. Drittlandtransfers

Wie bei Google/Firebase üblich, z. B. Standardvertragsklauseln.

7. Speicherdauer

Chatnachrichten (als Ciphertext in Firestore) und Chat-Anhänge in Storage werden 14 Tage ab Erstellung gespeichert und danach automatisch gelöscht. Konto-, Profil- und Kontaktdaten bleiben, solange das Konto aktiv ist und der Dienst sie benötigt. Backups/Logs begrenzt. Nach Kontolöschung Löschung/Anonymisierung soweit möglich; Gruppen-/Kanaldaten bei anderen Mitgliedern nach Produktlogik.

8. Sicherheit

HTTPS, Regeln, ggf. clientseitige Verschlüsselung, App Check, Header — siehe technische Doku.

9. Meldung von Datenschutzverletzungen

Werden uns Verletzungen der Sicherheit bekannt, die zu unbeabsichtigter oder unrechtmäßiger Vernichtung, Verlust, Änderung oder unbefugter Offenlegung personenbezogener Daten unter unserer Kontrolle führen, ergreifen wir angemessene Schritte zur Schadensbegrenzung und benachrichtigen nach gesetzlicher Pflicht Aufsichtsbehörden und/oder Betroffene unverzüglich im Rahmen des Gesetzes.

10. Ihre Rechte

Je nach Ort: Auskunft, Berichtigung, Löschung, Einschränkung, Widerspruch, Datenübertragbarkeit, Beschwerde bei Aufsichtsbehörde.

11. Automatisierte Entscheidungen

Wir nutzen Ihre Daten nicht für ausschließlich automatisierte Entscheidungen mit Rechtswirkung oder ähnlich erheblicher Wirkung, sofern wir nicht anderweitig mit Rechtsgrundlage informieren.

12. Kinder

Nicht unter dem in den Bedingungen genannten Mindestalter.

13. Cookies

Essenziell für Login/Sitzung; weitere nur mit Hinweis und ggf. Einwilligung.

14. Änderungen

Wir können die Erklärung aktualisieren.

15. Kontakt

Datenschutzanfragen an den Betreiber über die veröffentlichten Kontaktdaten.

Zuletzt aktualisiert: März 2026`,
} as const;
